/**
 * Free tool pages that render inside the homepage design (CreativeLandingShell:
 * the landing header, rail and footer, DM Sans / DM Mono, the neutral paper
 * and the green action colour) instead of the older orange app theme.
 *
 * Layout.tsx wraps these in `<main className="legacy-tool-content free-tool">`
 * and pages/free-tool-landing.css maps the pages' Tailwind tokens onto the
 * landing palette, so the page components themselves stay unchanged.
 *
 * Paths are language-free: Layout matches them against the path with the
 * /:lang prefix stripped. Song generators (/ai-music-generator and its genre
 * aliases) are deliberately not here: /ai-music-generator is also the
 * signed-in Create Song screen.
 */
export const FREE_TOOL_LANDING_PATHS: ReadonlySet<string> = new Set([
  // Audio tools
  "/reverse-audio",
  "/audio-cutter",
  "/volume-booster",
  "/pitch-changer",
  "/slowed-reverb",
  "/audio-joiner",
  "/audio-mastering",
  "/bpm-finder",
  "/key-finder",
  "/song-analyzer",
  "/tap-tempo",
  "/audio-to-midi",
  "/chord-progression-generator",
  "/8-bit-converter",
  // Converters (the hub plus every pair page)
  "/audio-converter",
  "/m4a-to-mp3",
  "/wav-to-mp3",
  "/mp3-to-wav",
  "/ogg-to-mp3",
  "/flac-to-mp3",
  "/opus-to-mp3",
  "/aac-to-mp3",
  "/mp4-to-mp3",
  "/mov-to-mp3",
  "/video-to-mp3",
  "/video-to-audio",
  "/mp4-to-wav",
  "/webm-to-mp3",
  "/mp3-to-ogg",
  "/wav-to-flac",
  // Audio to video
  "/mp3-to-mp4",
  "/audio-to-video",
  "/wav-to-mp4",
  "/m4a-to-mp4",
  "/add-music-to-video",
  "/audio-visualizer",
  // Lyrics and names
  "/rap-lyrics-generator",
  "/diss-track-generator",
  "/freestyle-lyrics-generator",
  "/drill-lyrics-generator",
  "/brat-lyrics-generator",
  "/hook-generator",
  "/rapper-name-generator",
  "/band-name-generator",
  "/artist-name-generator",
  "/album-name-generator",
  "/kpop-group-name-generator",
  "/song-title-generator",
  // Artwork
  "/band-logo-generator",
  "/album-cover-maker",
]);
